import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const Hashtag: React.FC<Props> = ({ accessibilityLabel, className }) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.375 5h-1.5l-.5 3.5h-3V10h2.786l-.572 4H5.625v1.5h2.75l-.5 3.5h1.5l.5-3.5h3.5l-.5 3.5h1.5l.5-3.5h2.75V14h-2.536l.572-4h2.714V8.5h-2.5l.5-3.5h-1.5l-.5 3.5h-3.5l.5-3.5zm2.214 9l.572-4h-3.5l-.572 4h3.5z'
        fill='currentColor'
      />
    </svg>
  </i>
);

Hashtag.displayName = 'Hashtag';
export default Hashtag;
